import {useEffect, useState} from 'react';
import sessionStore from 'client/Session/SessionStore';
import {getSchoolsOfAdmin} from 'lib/hooks/useHasProUpgrade';

export interface AdminSchool {
  id: string;
  name: string;
}

interface UseAdminSchoolsResult {
  schools: AdminSchool[];
  loading: boolean;
  error: Error | undefined;
}

/** The schools where the current user holds an approved administrator (non-teacher) role. */
export function useAdminSchools(): UseAdminSchoolsResult {
  const [schools, setSchools] = useState<AdminSchool[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    let subscribed = true;

    getSchoolsOfAdmin(sessionStore.getUserId())
      .then((schoolList) => {
        if (!subscribed) {
          return;
        }
        // Dynamic JSON:API mandark models; narrow to the getters used here.
        const mapped = (
          schoolList.toArray() as Array<{getId: () => string; getName: () => string}>
        ).map((school) => ({id: school.getId(), name: school.getName()}));
        setSchools(mapped);
        setLoading(false);
      })
      .catch((e) => {
        if (!subscribed) {
          return;
        }
        const fetchError = e as Error;
        logger.error('Failed to fetch admin schools: %o', fetchError);
        setError(fetchError);
        setLoading(false);
      });

    return () => {
      subscribed = false;
    };
  }, []);

  return {schools, loading, error};
}
